<!--
 * @Author: guoyu
 * @Date: 2021-05-13 15:36:43
 * @LastEditors: your name
 * @LastEditTime: 2021-05-24 16:08:15
 * @Description: 好評後提示用戶追蹤陪陪
-->
<template>
  <NormalPopup
    class="follow-popup"
    :show="show"
    :defaultClose="true"
    @destroy="dy"
    @close="$emit('close')"
  >
    <template v-slot="{ close }">
      <fps-avatar class="follow-avatar" :src="orderAvatar"></fps-avatar>
      <p class="follow-nickname">{{ orderInfo.playerUserNickname }}</p>
      <p class="follow-tip">謝謝好評，追蹤我看最新動態喔👇</p>
      <div class="handle-button follow-button" @click="follow(close)">追蹤</div>
      <div class="handle-button close-button" @click="close">下次吧</div>
    </template>
  </NormalPopup>
</template>
<script>
import NormalPopup from '@/components/common/popup';
import { inFollow } from '@/api/app';
import { followUser } from '@/api/quick-order';
export default {
  components: {
    NormalPopup
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    orderAvatar: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    /**
     * @description: 是否已经关注了陪陪
     * @param {*}
     * @return {*}
     */
    hasFollow() {
      const load = this.$loading()
      inFollow({uuid: this.orderInfo.playerUserUuid}).then(({data})=>{
        load.close()
        if(!data) {
          this.show = true
        } else {
          this.dy()
        }
      }).catch(()=>{
        load.close()
        this.dy()
      })
    },
    dy() {
      this.$emit('close')
      // 用于函数式调用，关闭弹窗时销毁自己
      this.$emit('destroy');
    },
    follow(close) {
      followUser({
        followOptType: 'Follow',
        uuid: this.orderInfo.playerUserUuid
      }).then(() => {
        close()
        this.$message.success('追蹤成功');
      });
    }
  },
  mounted() {
    this.hasFollow()
  }
};
</script>
<style lang="scss" scoped>
.follow-popup /deep/ .content {
  width: 340px;
  padding: 16px 20px 28px;
  text-align: center;
  background: #ffffff;
  border-radius: 14px;
}
.follow-avatar {
  display: inline-block;
  height: 64px!important;
  width: 64px!important;
}
.follow-nickname {
  margin: 6px 0 20px;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #222c43;
}
.follow-tip {
  font-size: 14px;
  line-height: 20px;
  color: #636d86;
}
.handle-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  border-radius: 36px;
  font-weight: 500;
  font-size: 14px;
  color: #222c43;
  cursor: pointer;
}
.follow-button {
  margin: 20px 0 12px;
  background: #fed838;
}
.close-button {
  background: #f1f4f6;
}
</style>
